export default ({ authorizedGET }, endpoints) => {
  const getAll = async () => {
    return authorizedGET(endpoints.documentation.list);
  };

  const getById = async (id) => {
    const url = endpoints.documentation.item.replace(':id', id);
    return authorizedGET(url);
  };

  return {
    getAll,
    getById,
  };
};
